import * as angular from 'angular';

class RuntimeStartBeforeEndValidator implements ng.IDirective {
    public require = 'ngModel';
    public restrict = 'A';
    public scope = false;

    public link: ng.IDirectiveLinkFn = (
        scope: ng.IScope,
        element: JQuery,
        attributes: ng.IAttributes,
        ngModelCtrl: ng.INgModelController
    ) => {
        ngModelCtrl.$validators['pkpRuntimeStartBeforeEndValidator'] =
            this.validate;
    };

    private validate(modelValue) {
        if (!modelValue || !modelValue.start || !modelValue.end) {
            return true;
        }

        var runtimeStart = moment(modelValue.start);
        var runtimeEnd = moment(modelValue.end);

        return runtimeStart.isBefore(runtimeEnd, 'minute');
    }
}

angular
    .module('app')
    .directive(
        'pkpRuntimeStartBeforeEndValidator',
        () => new RuntimeStartBeforeEndValidator()
    );
